const role = {
  duplicate: 4000,
  not_found: 4001,
  insufficient: 4002,
};

export default role;
